import { render, staticRenderFns } from "./ed-calendar-create-events.vue?vue&type=template&id=ed1174a2&scoped=true&"
import script from "./ed-calendar-create-events.ts?vue&type=script&lang=ts&"
export * from "./ed-calendar-create-events.ts?vue&type=script&lang=ts&"
import style0 from "./ed-calendar-create-events.scss?vue&type=style&index=0&id=ed1174a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1174a2",
  null
  
)

export default component.exports